import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppShell } from "./components/AppShell";
import Overview from "./pages/Overview";
import StockHolding from "./pages/StockHolding";
import WeeklyReport from "./pages/WeeklyReport";
import Uploads from "./pages/Uploads";
import SettingsPage from "./pages/SettingsPage";
import { useTheme } from "./lib/theme";

function App() {
  const theme = useTheme();
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<Overview />} />
          <Route path="/stock" element={<StockHolding />} />
          <Route path="/report" element={<WeeklyReport />} />
          <Route path="/uploads" element={<Uploads />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Routes>
      <Toaster theme={theme} position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
